import React, { useEffect, useState, useReducer } from 'react';
import { useAuth } from '../../Context';

import { Empty, Row, Col, Typography, Button, Space, Table, Form, Input, InputNumber, Modal, Spin, Tooltip, message, Popover, Avatar, Card, Upload, DatePicker, Radio } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { PlusOutlined, DeleteOutlined, EditOutlined, EyeOutlined, InboxOutlined, InfoOutlined, ContainerOutlined, DownloadOutlined, CopyOutlined } from '@ant-design/icons';

import { ASN_DATA_LIST, ASN_DATA_LIST_SUCCESS, ASN_DATA_LIST_ERROR } from './constants';
import { ASN_DATA_DETAILS, ASN_DATA_DETAILS_SUCCESS, ASN_DATA_DETAILS_ERROR } from './constants';
import { ADD_ASN_DATA_DETAILS, ADD_ASN_DATA_DETAILS_SUCCESS, ADD_ASN_DATA_DETAILS_ERROR } from './constants';
import { UPDATE_ASN_DATA, UPDATE_ASN_DATA_SUCCESS, UPDATE_ASN_DATA_ERROR } from './constants';
import { DELETE_ASN_DATA, DELETE_ASN_DATA_SUCCESS, DELETE_ASN_DATA_ERROR } from './constants';

import asnDataReducer from './reducer';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';

import { useFormik } from 'formik';
import axios from 'axios';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;
const { Dragger } = Upload;

const ALLOWED_EXTENSIONS = ['txt', 'gpx', 'ods', 'csv'];

export default function AsnData() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const prefix = dashboardtype.toUpperCase();
	const authtoken = localStorage.getItem(`${prefix}_ACCESS_TOKEN`);
	const initalState = {
		asnData: [],
		details: null,
		pending: false,
		error: false,
		pagination: { total: 0, limit: 10, skip: 0, current: 1, pageSize: 10 }
	};
	const [data, dispatch] = useReducer(asnDataReducer, initalState);
	const permission = localStorage.getItem(`${prefix}_PERMISSION`);

	const [showAddAsnDataModal, setShowAddAsnDataModal] = useState(false);
	const [showEditAsnDataModal, setShowEditAsnDataModal] = useState(false);
	const [showDeleteAsnDataModal, setShowDeleteAsnDataModal] = useState(false);
	const [fileList, setFileList] = useState([]);
	const [uploading, setUploading] = useState(false);
	const [showFetchAndDownloadModal, setShowFetchAndDownloadModal] = useState(false);
	const [selectedTemplate, setSelectedTemplate] = useState('ods');

	useAuth();
	const apiUrl = localStorage.getItem(`${prefix}_API_URL`);
	const api = apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	const langid = localStorage.getItem(`${prefix}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${prefix}_LANGUAGE_ID`)) : 2;
	const langdata = langid == 1 ? arabiclan : langid == 2 ? englan : langid == 3 ? frenchlan : langid == 4 ? germanlan : langid == 5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const t = (key, fallback) => (langdata && langdata[key] ? langdata[key] : fallback);

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${prefix}_TIMEOUT`) == 'null' || localStorage.getItem(`${prefix}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) : parseInt(localStorage.getItem(`${prefix}_TIMEOUT`));
	const uploadTimeout = Math.max(timeout, 120000);
	const featuresModule = JSON.parse(localStorage.getItem(`${prefix}_FEATURES_MODULE_DASHBOARD`));
	const navigate = useNavigate();

	// Date / time formats (same logic as the Task list page)
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const settingsdateformat = localStorage.getItem(`${prefix}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${prefix}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${prefix}_DATE_FORMAT`);
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;
	const settingstimeformat = localStorage.getItem(`${prefix}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${prefix}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${prefix}_TIME_FORMAT`);

	const authHeaders = {
		accept: 'application/json',
		Authorization: `Bearer ${authtoken}`
	};

	const handleError = (error) => {
		if (error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
			message.config({ duration: 5, maxCount: 1 });
			message.open({
				type: 'error',
				content: t('ItseemsthenetworkisunreachablePleaserefreshtheapplication', 'It seems the network is unreachable. Please refresh the application.'),
			});
		} else if (error.response && error.response.data && error.response.data.message) {
			Modal.warning({ title: error.response.data.message });
		}
	};

	
	const columns = [
		{
			title: t('Name', 'Name'),
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: t('Latitude', 'Latitude'),
			dataIndex: 'latitude',
			key: 'latitude',
		},
		{
			title: t('Longitude', 'Longitude'),
			dataIndex: 'longitude',
			key: 'longitude',
		},
		{
			title: t('SpeedMs', 'Speed (m/s)'),
			dataIndex: 'speed',
			key: 'speed',
			render: (value) => (value === null || value === undefined ? '-' : value),
		},
		{
			title: t('DateTime', 'Date & Time'),
			dataIndex: 'datetime',
			key: 'datetime',
		},
		{
			title: t('Actions', 'Actions'),
			key: 'action',
			render: (_, record) => (
				permission === 'superadmin' || permission === 'admin' ? (
					<Space size="middle">
						<a title={t('EditAsnData', 'Edit ASN Data')} onClick={() => openEditAsnDataModal(record)}><EditOutlined /></a>
						<a title={t('DeleteAsnData', 'Delete ASN Data')} onClick={() => openDeleteAsnDataModal(record)}><DeleteOutlined /></a>
					</Space>
				) : (
					<Space size="middle">
						<a title={t('EditAsnData', 'Edit ASN Data')} onClick={() => openEditAsnDataModal(record)}><EyeOutlined /></a>
					</Space>
				)
			)
		}
	];

	
	const openAddAsnDataModal = () => {
		setFileList([]);
		setShowAddAsnDataModal(true);
	};

	const closeAddAsnDataModal = () => {
		setFileList([]);
		setShowAddAsnDataModal(false);
	};

	const openEditAsnDataModal = (record) => {
		loadAsnDataDetails(record);
		setShowEditAsnDataModal(true);
	};

	const closeEditAsnDataModal = () => {
		setShowEditAsnDataModal(false);
	};

	const openDeleteAsnDataModal = (record) => {
		loadAsnDataDetails(record);
		setShowDeleteAsnDataModal(true);
	};

	const closeDeleteAsnDataModal = () => {
		setShowDeleteAsnDataModal(false);
	};

	
	const deleteAsnData = () => {
		const id = parseInt(data.details.id);

		dispatch({ type: DELETE_ASN_DATA });

		const config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/aisdata/${id}`,
			timeout: timeout,
			headers: { ...authHeaders, 'Content-Type': 'application/json' }
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type: DELETE_ASN_DATA_SUCCESS, payload: response });
					setShowDeleteAsnDataModal(false);

					// If the last row of a page was deleted, step back one page
					const current = data.pagination.current || 1;
					const pageSize = data.pagination.pageSize || 10;
					const goTo = data.asnData.length === 1 && current > 1 ? current - 1 : current;
					loadAsnData({ current: goTo, pageSize });
				} else {
					dispatch({ type: DELETE_ASN_DATA_ERROR });
				}
			})
			.catch((error) => {
				dispatch({ type: DELETE_ASN_DATA_ERROR });
				handleError(error);
			});
	};

	
	useEffect(() => {
		if (featuresModule.asnDataEnabled == false) {
			navigate('/dashboard');
		}

		window.scrollTo(0, 0);
		localStorage.setItem(prefix + '_ACTIVE_MENU_ITEM', 1140);
	}, []);

	useEffect(() => {
		dispatch({ type: ASN_DATA_LIST });
		loadAsnData(1);
	}, []);

	
	const loadAsnData = (pagination) => {
		const _pagination = {};
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip = pagination.current ? parseInt((pagination.current - 1) * _pagination.limit) : 0;

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/aisdata?$sort[id]=-1&$limit=${_pagination.limit}&$skip=${_pagination.skip}`,
			timeout: timeout,
			headers: { ...authHeaders, 'Content-Type': 'application/json' }
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({
						type: ASN_DATA_LIST_SUCCESS,
						page: pagination.current,
						pageSize: pagination.pageSize,
						payload: response.data
					});
				}
			})
			.catch((error) => {
				dispatch({ type: ASN_DATA_LIST_ERROR });
				handleError(error);
			});
	};

	const loadAsnDataDetails = (record) => {
		dispatch({ type: ASN_DATA_DETAILS });

		if (!record) {
			dispatch({ type: ASN_DATA_DETAILS_ERROR });
		} else {
			dispatch({ type: ASN_DATA_DETAILS_SUCCESS, payload: record });
		}
	};

	
	const uploadProps = {
		name: 'file',
		multiple: false,
		maxCount: 1,
		accept: '.txt,.gpx',
		fileList: fileList,
		beforeUpload: (file) => {
			const ext = file.name.split('.').pop().toLowerCase();
			if (!ALLOWED_EXTENSIONS.includes(ext)) {
				message.error(t('OnlytxtandgpxfilesareallowedMsg', 'Only .txt, .gpx , .ods & .csv files are allowed.'));
				return Upload.LIST_IGNORE;
			}
			setFileList([file]);
			return false;
		},
		onRemove: () => {
			setFileList([]);
		},
	};

	const saveAsnData = () => {
		if (fileList.length === 0) {
			Modal.warning({ title: t('Pleaseselectafiletoupload', 'Please select a .txt or .gpx file to upload.') });
			return;
		}

		const formData = new FormData();
		formData.append('file', fileList[0].originFileObj || fileList[0]);

		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			maxContentLength: Infinity,
			url: `${api}/aisdata`,
			timeout: uploadTimeout,
			headers: authHeaders,
			data: formData
		};

		setUploading(true);
		dispatch({ type: ADD_ASN_DATA_DETAILS });

		axios
			.request(config)
			.then((response) => {
				setUploading(false);
				if (response.status === 200 || response.status === 201) {
					dispatch({ type: ADD_ASN_DATA_DETAILS_SUCCESS, payload: response });
					const inserted = response.data && response.data.inserted;
					Modal.success({
						title: inserted
							? `${t('AsnDataAddedsuccessfully', 'ASN Data Added Successfully.')} (${inserted})`
							: t('AsnDataAddedsuccessfully', 'ASN Data Added Successfully.')
					});
					closeAddAsnDataModal();
					loadAsnData(1); // newest rows first, so go back to page 1
				} else {
					dispatch({ type: ADD_ASN_DATA_DETAILS_ERROR });
					Modal.warning({ title: t('UnabletoAddtheasndata', 'Unable to Add the ASN data.') });
				}
			})
			.catch((error) => {
				setUploading(false);
				dispatch({ type: ADD_ASN_DATA_DETAILS_ERROR });
				if (error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					handleError(error);
				} else {
					Modal.warning({
						title: (error.response && error.response.data && error.response.data.message) || t('UnabletoAddtheasndata', 'Unable to Add the ASN data.')
					});
				}
			});
	};

	
	const updateAsnDataFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: data.details ? data.details.name : '',
			latitude: data.details ? data.details.latitude : null,
			longitude: data.details ? data.details.longitude : null,
			speed: data.details ? data.details.speed : null,
			datetime: data.details ? data.details.datetimeUTC : ''
		},
		onSubmit: (values) => {
			const id = data.details.id;
			const name = values.name ? String(values.name).trim() : '';
			const latitude = values.latitude;
			const longitude = values.longitude;
			const speed = values.speed;
			const datetime = values.datetime ? values.datetime : '';

			if (!name) {
				Modal.warning({ title: t('PleaseprovideavalidName', 'Please provide a valid Name.') });
				return false;
			}
			if (latitude === null || latitude === undefined || isNaN(latitude) || latitude < -90 || latitude > 90) {
				Modal.warning({ title: t('PleaseprovideavalidLatitude', 'Please provide a valid Latitude (-90 to 90).') });
				return false;
			}
			if (longitude === null || longitude === undefined || isNaN(longitude) || longitude < -180 || longitude > 180) {
				Modal.warning({ title: t('PleaseprovideavalidLongitude', 'Please provide a valid Longitude (-180 to 180).') });
				return false;
			}
			if (speed !== null && speed !== undefined && (isNaN(speed) || speed < 0)) {
				Modal.warning({ title: t('PleaseprovideavalidSpeed', 'Please provide a valid Speed (0 or greater).') });
				return false;
			}
			if (!datetime || isNaN(Date.parse(datetime))) {
				Modal.warning({ title: t('PleaseprovideavalidDateTime', 'Please select a valid Date & Time.') });
				return false;
			}

			const payload = { name, latitude, longitude, datetime };
			if (speed !== null && speed !== undefined) {
				payload.speed = speed;
			}

			const config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/aisdata/${id}`,
				timeout: timeout,
				headers: { ...authHeaders, 'Content-Type': 'application/json' },
				data: payload
			};

			dispatch({ type: UPDATE_ASN_DATA });

			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({ type: UPDATE_ASN_DATA_SUCCESS, payload: response });
						Modal.success({ title: t('AsnDataupdatedsuccessfully', 'ASN Data updated successfully.') });
						setShowEditAsnDataModal(false);
						// stay on the page the user is currently viewing
						loadAsnData({ current: data.pagination.current, pageSize: data.pagination.pageSize });
					} else {
						dispatch({ type: UPDATE_ASN_DATA_ERROR });
						Modal.warning({ title: t('Unabletoupdatetheasndata', 'Unable to update the ASN data.') });
					}
				})
				.catch((error) => {
					dispatch({ type: UPDATE_ASN_DATA_ERROR });
					handleError(error);
				});
		}
	});

	// Date picker -> ISO string (same idea as dateHandler in the Task list page)
	const dateHandler = (date) => {
		const isodate = date ? date.toDate().toISOString() : '';
		updateAsnDataFormik.setFieldValue('datetime', isodate);
	};

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}>
			<p>{t('AsnDataContent1', 'This module is used to upload and manage AIS data, including vessel position, speed, and movement information.')}</p>
		</Card>
	);


	const openShowFetchAndDownloadModal = () => {
		setSelectedTemplate('ods');
		setShowFetchAndDownloadModal(true);
	};

	const closeShowFetchAndDownloadModal = () => {
		setShowFetchAndDownloadModal(false);
	};

	const downloadTemplate = () => {
		const option = TEMPLATE_OPTIONS.find((o) => o.value === selectedTemplate);
		if (!option) return;

		const a = document.createElement('a');
		a.href = `${process.env.PUBLIC_URL}/templates/${option.file}`;
		a.download = option.file;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	};

	const TEMPLATE_OPTIONS = [
		{ value: 'ods', label: '.ods template', file: 'template_ods.ods' },
		{ value: 'gpx', label: '.gpx template', file: 'template-gpx.gpx' },
		{ value: 'txt', label: '.txt template', file: 'template_txt.txt' },
		{ value: 'csv', label: '.csv template', file: 'template_csv.csv' }
	];

	
	return (
		permission === 'superadmin' || permission === 'admin' ?

			<>
				<Content>
					<Row style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems: 'center',
					}}
					>
						<Col span={12}>
							<Row>
								<Space>
									<ContainerOutlined style={{ fontSize: '30px' }} />
								</Space>
								<Space>&nbsp;&nbsp;</Space>
								<Title level={4} style={{ paddingTop: '10px' }}>{t('AsnData', 'ASN Data')}</Title>
							</Row>
						</Col>

						<Col span={12}>
							<Row justify="end">
								<Col>
									<Tooltip placement="bottom" title={t('Add', 'Add')}>
										<Space>
											<Button type="primary" onClick={openAddAsnDataModal} style={{ margin: '5px' }}><PlusOutlined />{t('AddNew', 'Add New')}</Button>
										</Space>
									</Tooltip>
									<Tooltip placement="bottom" title={t('DownloadTemplates', 'Download Templates')}>
										<Space>
											<Button  onClick={openShowFetchAndDownloadModal} style={{ margin: '5px' }}><CopyOutlined />{t('Templates', 'Templates')}</Button>
										</Space>
									</Tooltip>
									<Space>&nbsp;&nbsp;</Space>
									<Space>
										<Typography>
											<Popover title={t('AsnData', 'ASN Data')} content={infoContent} trigger="click">
												<Avatar size="small"><InfoOutlined /></Avatar>
											</Popover>
										</Typography>
									</Space>
								</Col>
							</Row>
						</Col>
					</Row>

					<Row span={24} style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems: 'center'
					}} >
						<Col span={24}>
							{data && data.asnData.length > 0 ? (
								<Table
									rowKey="id"
									scroll={{ x: 900 }}
									columns={columns}
									dataSource={data.asnData}
									pagination={{
										...data.pagination,
										showSizeChanger: false
									}}
									onChange={loadAsnData}
								/>
							) : (
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)}
						</Col>
					</Row>

					{/* <Row gutter={{
						xs: 8,
						sm: 16,
						md: 24,
						lg: 32,
					}}
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center',
						justifyContent:'center',
						display:'flex'
					}} 
					>
						<Col style={{
							alignItems:'left',
							justifyContent:'left',
							display:'flex',
							padding:'10px'
						}}  className="gutter-row" span={24}>
							<Button  type="primary" title={langdata && langdata.DownloadTemplates ? langdata.DownloadTemplates:'Download Templates'} onClick={openShowFetchAndDownloadModal}><DownloadOutlined />{langdata && langdata.Download ? langdata.Download:'Download'}</Button>
						</Col>

					</Row> */}
				</Content>

				<Spin fullscreen spinning={data.pending || uploading} />

				{/* Add ASN Data Starts */}
				<Modal
					title={t('AddAsnData', 'Add ASN Data')}
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={showAddAsnDataModal}
					onCancel={closeAddAsnDataModal}
					footer={[
						<Space key="footer">
							<Button onClick={closeAddAsnDataModal}>{t('CLOSE', 'CLOSE')}</Button>
							<Button type="primary" loading={uploading} onClick={saveAsnData}>{t('SAVE', 'SAVE')}</Button>
						</Space>
					]}
					width={800}
				>
					<Dragger {...uploadProps}>
						<p className="ant-upload-drag-icon">
							<InboxOutlined />
						</p>
						<p className="ant-upload-text">{t('Clickordragfiletothisareatoupload', 'Click or drag a file to this area to upload')}</p>
						<p className="ant-upload-hint">
							{t('OnlytxtandgpxfilesaresupportedHint', 'Only a single .txt or .gpx file is supported.')}
						</p>
					</Dragger>
				</Modal>
				{/* Add ASN Data Ends */}

				{/* Edit ASN Data Starts */}
				<Modal
					title={t('EditAsnData', 'Edit ASN Data')}
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={showEditAsnDataModal}
					onCancel={closeEditAsnDataModal}
					footer={[
						<Space key="footer">
							<Button onClick={closeEditAsnDataModal}>{t('CLOSE', 'CLOSE')}</Button>
							<Button type="primary" onClick={updateAsnDataFormik.handleSubmit}>{t('SAVE', 'SAVE')}</Button>
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical">
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={t('Name', 'Name')} required>
									<Input
										name="name"
										onChange={updateAsnDataFormik.handleChange}
										placeholder={t('PleaseenterName', 'Please enter the Name')}
										value={updateAsnDataFormik.values.name}
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item label={t('Latitude', 'Latitude')} required>
									<InputNumber
										style={{ width: '100%' }}
										min={-90}
										max={90}
										step={0.0001}
										stringMode={false}
										placeholder={t('PleaseenterLatitude', 'Please enter the Latitude')}
										value={updateAsnDataFormik.values.latitude}
										onChange={(value) => updateAsnDataFormik.setFieldValue('latitude', value)}
									/>
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item label={t('Longitude', 'Longitude')} required>
									<InputNumber
										style={{ width: '100%' }}
										min={-180}
										max={180}
										step={0.0001}
										stringMode={false}
										placeholder={t('PleaseenterLongitude', 'Please enter the Longitude')}
										value={updateAsnDataFormik.values.longitude}
										onChange={(value) => updateAsnDataFormik.setFieldValue('longitude', value)}
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item label={t('SpeedMs', 'Speed (m/s)')}>
									<InputNumber
										style={{ width: '100%' }}
										min={0}
										step={0.1}
										stringMode={false}
										placeholder={t('PleaseenterSpeed', 'Please enter the Speed')}
										value={updateAsnDataFormik.values.speed}
										onChange={(value) => updateAsnDataFormik.setFieldValue('speed', value)}
									/>
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item label={t('DateTime', 'Date & Time')} required>
									<DatePicker
										name="datetime"
										style={{ width: '100%' }}
										allowClear={false}
										showTime
										format={settingsdateformat + ' ' + settingstimeformat}
										placeholder={t('PleaseSelectDateTime', 'Please select the date & time')}
										value={updateAsnDataFormik.values.datetime ? dayjs(updateAsnDataFormik.values.datetime) : null}
										onChange={(date) => { dateHandler(date); }}
									/>
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
				{/* Edit ASN Data Ends */}

				{/* Delete ASN Data Starts */}
				<Modal title={t('Confimdelete', 'Confirm delete')} open={showDeleteAsnDataModal} onOk={deleteAsnData} onCancel={closeDeleteAsnDataModal}>
					<Row style={{
						marginTop: '10px',
						marginBottom: '10px',
						background: '#FFFFFF',
						alignItems: 'center'
					}} >
						<Col span={1}>
							<DeleteOutlined style={{ fontSize: '14px' }} />
						</Col>
						<Col span={23}> {t('Areyousureyouwanttodeletethisasndata', 'Are you sure you want to delete this AIS data?')}</Col>
					</Row>
				</Modal>


				<Modal
					title={t('DownloadTemplate', 'Download Template')}
					centered
					destroyOnClose={true}
					open={showFetchAndDownloadModal}
					onCancel={closeShowFetchAndDownloadModal}
					footer={
						<div style={{ textAlign: 'left' }}>
							<Button type="primary" onClick={downloadTemplate}>
								<DownloadOutlined /> {t('DownloadTemplate', 'Download Template')}
							</Button>
						</div>
					}
					width={540}
				>
					<Radio.Group
						value={selectedTemplate}
						onChange={(e) => setSelectedTemplate(e.target.value)}
					>
						<Space direction="vertical">
							{TEMPLATE_OPTIONS.map((opt) => (
								<Radio key={opt.value} value={opt.value}>{opt.label}</Radio>
							))}
						</Space>
					</Radio.Group>
				</Modal>
			</> : null
	);
}